<template>
  <div>
    <app-header></app-header>

    <div class="container content">
      <div class="no-players">
        <div class="text">
          Cамоконтроль рисков нарушения антимонопольного законодательства.
          <br>
          Добро пожаловать!
          <br>
        </div>
        <div class="col">
          <router-link :to="{name: 'Start', params: {slug: slug}}">
            <div class="btn btn-lg">
              Начать
            </div>
          </router-link>
        </div>
      </div>
    </div>
    <app-footer></app-footer>
  </div>
</template>

<script>
  export default {
    name: 'Index',
    data () {
      return {
        slug: process.env.ORG_SLUG
      }
    },
    created () {
      this.$store.dispatch('signout')
    }
  }
</script>

<style scoped lang="scss">

  .no-players {
    margin: 10vh 0;
    .text {
      color: #000 !important;
      font-weight: 400;
    }
    .btn {
      display: block;
      margin: 20px auto;
    }
  }

  .col {
    width: 485px;
    max-width: 100%;
    margin: 0 auto;
  }

  .form-group {
    display: flex;
    justify-content: space-between;
    align-items: center;
    .btn {
      margin: 20px 0;
    }
  }

  .content {
    min-height: calc(100vh - 212px);
  }
</style>



// WEBPACK FOOTER //
// src/pages/Index.vue